import { render, staticRenderFns } from "./AccountActivatePage.vue?vue&type=template&id=6ba8a17f&scoped=true&"
import script from "./AccountActivatePage.vue?vue&type=script&lang=ts&"
export * from "./AccountActivatePage.vue?vue&type=script&lang=ts&"
import style0 from "./AccountActivatePage.vue?vue&type=style&index=0&id=6ba8a17f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba8a17f",
  null
  
)

export default component.exports